import React from 'react';

import { useMediaQuery } from 'react-responsive'

import { Slider } from '../components/Slider'

import {
    Button,
    Toolbar,
    Window,
    WindowHeader,
    WindowContent
} from 'react95';


export const Projects = () => {
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })


    return (
        <Window style={{ width: 950, maxWidth: "75vw", marginTop: "20px",marginBottom:"20x" }} >
            <WindowHeader>

                projects.exe
        </WindowHeader>
            <Toolbar noPadding>
                <Button variant='menu' disabled>
                    Upload
        </Button>
                <Button variant='menu' disabled>
                    Save
        </Button>
                <Button
                    variant='menu'
                    disabled
                >
                    Share
          </Button>
            </Toolbar>
            <WindowContent >
                <Slider portair={isPortrait}/>
            </WindowContent>
        </Window>
    );
}